import { cn, tv } from "@utils/tw"

export type FieldProps = {
  children: React.ReactNode
  className?: string
}

export function FieldRow(props: FieldProps) {
  const styles = fieldRowStyles({})
  return <div className={cn(styles.base(), props.className)}>{props.children}</div>
}

export const fieldRowStyles = tv({
  slots: {
    base: "flex [&_>_div]:flex-1 [&_>_div]:w-[1px] gap-4",
  },
})
